import React, { useContext } from "react";
import { Grid, makeStyles } from "@material-ui/core";
import { DEFAULT_BOX_SHADOW } from "App/constants";
import { FormContext } from "../../context/FormContext";
import { convertToValidPrice, formatNumber, isNull } from "App/utils/helpers";

const useStyles = makeStyles({
  titleTagihan: {
    fontWeight: 600,
    fontSize: 16,
  },
  rootTagihan: {
    padding: "1rem",
    boxShadow: DEFAULT_BOX_SHADOW,
    borderRadius: "8px",
    // height: "200px",
  },
  tableTagihan: {
    lineHeight: "1.75rem",
  },

  row: {
    display: "flex",
    flexDirection: "row",
  },

  col: {
    float: "left",
    width: "50%",
    flexDirection: "column",
    flex: "1 1 auto",
    margin: "15px",
  },
});

function TabRingkasan({ setNewData }) {
  const { formData } = useContext(FormContext);
  const classes = useStyles();

  // useEffect(() => {
  //   setNewData();
  // }, [formData.tagihan_id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Grid container spacing={2}>
        <Grid item sm={4}>
          <TotalTagihan classes={classes} data={formData} />
        </Grid>
        <Grid item sm={4}>
          <TotalPotongan classes={classes} data={formData} />
        </Grid>
        <Grid item sm={4}>
          <Rincian classes={classes} data={formData} />
        </Grid>
      </Grid>
    </>
  );
}

const TotalTagihan = ({ classes, data }) => {
  const subTotal =
    convertToValidPrice(data?.total_harga_tagihan) -
    convertToValidPrice(data?.total_bayar_tagihan);
  return (
    <div className={classes.rootTagihan}>
      <p className={classes.titleTagihan}>Rincian Total Tagihan </p>
      <div className={classes.row}>
        <div className={classes.col}>
          <table width={"100%"} className={classes.tableTagihan}>
            <tbody>
              <tr>
                <td width={"50%"}>Total</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">{formatNumber(data?.total_harga_tagihan)}</td>
              </tr>
              {/* <tr>
                <td width={"50%"}>Selisih Ditagih</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">
                  {formatNumber(
                    isNull(data?.selisih_tagihan) ? 0 : data?.selisih_tagihan
                  )}
                </td>
              </tr> */}
              <tr>
                <td width={"50%"}>Bayar</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">{formatNumber(subTotal)}</td>
              </tr>
              <tr>
                <td></td>
                <td
                  colSpan={2}
                  style={{
                    borderBottom: "1px dashed black",
                    padding: "0.5rem 0",
                  }}
                ></td>
              </tr>
              <tr>
                <td width={"50%"}>Sisa</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">{formatNumber(data?.total_bayar_tagihan)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const TotalPotongan = ({ classes, data }) => {
  const potongan =
    convertToValidPrice(data?.total_bayar_tagihan) -
    convertToValidPrice(data?.total_diskon);
  // const taxPercent = isNaN(tax) ? 0 : tax.toFixed(2);
  return (
    <div className={classes.rootTagihan}>
      <p className={classes.titleTagihan}>Rincian Potongan Dalam Rekap</p>
      <div className={classes.row}>
        <div className={classes.col}>
          <table width={"100%"} className={classes.tableTagihan}>
            <tbody>
              <tr>
                <td width={"50%"}>Total</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">{formatNumber(data?.total_bayar_tagihan)}</td>
              </tr>
              <tr>
                <td width={"40%"}>Potongan ({formatNumber(data?.diskon)}%)</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">{formatNumber(data?.total_diskon)}</td>
              </tr>
              {/* <tr>
                <td width={"40%"} height={'27vh'}></td>
                <td width={"5%"}></td>
                <td align="right"></td>
              </tr> */}
              <tr>
                <td></td>
                <td
                  colSpan={2}
                  style={{
                    borderBottom: "1px dashed black",
                    padding: "0.5rem 0",
                  }}
                ></td>
              </tr>
              <tr>
                <td width={"50%"}>Sub Total</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">{formatNumber(potongan)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const Rincian = ({ classes, data }) => {
  const total =
    convertToValidPrice(data?.total_bayar_tagihan) -
    convertToValidPrice(data?.total_diskon);
  return (
    <div className={classes.rootTagihan}>
      <p className={classes.titleTagihan}> Rincian Total Dalam Rekap </p>
      <div className={classes.row}>
        <div className={classes.col}>
          <table width={"100%"} className={classes.tableTagihan}>
            <tbody>
              <tr>
                <td width={"50%"}>Total</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">{formatNumber(total)}</td>
              </tr>
              <tr>
                <td width={"50%"}>Bayar</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">{formatNumber(data?.total_dibayar)}</td>
              </tr>
              {/* <tr>
                <td width={"40%"} height={'27vh'}></td>
                <td width={"5%"}></td>
                <td align="right"></td>
              </tr> */}
              <tr>
                <td></td>
                <td
                  colSpan={2}
                  style={{
                    borderBottom: "1px dashed black",
                    padding: "0.5rem 0",
                  }}
                ></td>
              </tr>
              <tr>
                <td width={"50%"}>Sisa</td>
                <td width={"5%"}>Rp.</td>
                <td align="right">
                  {data?.total_dibayar > 0
                    ? formatNumber(data?.sisa_harga_tagihan)
                    : formatNumber(total)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TabRingkasan;
